import React, { useEffect, useState } from "react";
import "./transaction.scss";
import moment from "moment";
import jsonData from "./transaction.json";
import { DatePicker, Input, Form, Tag, Table } from "antd";
import { CalendarOutlined } from "@ant-design/icons";
import { useNavigate } from 'react-router-dom';

const { RangePicker } = DatePicker;

function Refund() {
  const [search, setSearch] = useState("");
  const [filterText, setfilterText] = useState('Transaction ID, Email ID');
  const [loading, setLoading] = useState();
  const [selectedDate, setSelectedDate] = useState(null);
  const [tableParams, setTableParams] = useState({
    current: 1,
    pageSize: 10,
  });

  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  const handleFromDateChange = (date) => {
    setFromDate(date);
  };

  const handleToDateChange = (date) => {
    setToDate(date);
  };
  const navigate = useNavigate();

  //for transaction pages
  const HandleChange = () => {
    navigate('/transactions');
  };


  const columns = [
    {
      title: '#',
      dataIndex: 'key',
      key: 'key',
    },
    {
      title: 'DATE',
      dataIndex: 'date',
    },
    {
      title: 'TRANSACTION ID',
      dataIndex: 'transaction_id',
      sorter: (a, b) => a.transaction_id.localeCompare(b.transaction_id)
    },
    {
      title: 'PAYMENT MODE',
      dataIndex: 'payment_mode',
    },
    {
      title: 'EMAIL',
      dataIndex: 'email',
      sorter: (a, b) => a.email.localeCompare(b.email)
    },
    {
      title: 'AMOUNT',
      dataIndex: 'amount',
    },

    {
      title: 'STATUS',
      dataIndex: 'status',

    },
  ];

  var data =
    jsonData &&
    jsonData.transactionsData.length > 0 &&
    jsonData.transactionsData.map((items, key) => {
      return {
        key: key + 1,
        transaction_id: items.transaction_id,
        email: items.email,
        payment_mode: items.Payment_Mode,
        amount: `₹${items.amount}`,
        date: (<>
          <p className="m-0 p-0">
            {moment(items.date).format("DD MMMM YYYY")}
          </p>
          <p className="m-0 p-0">
            {moment(new Date(items.date)).format("hh:mm:ss A")}
          </p>
        </>),
        status: <Tag color={items.status === 'Successful' ? "green" : items.status === 'Pending' ? "yellow" : "red"} className="draft">{items.status === 'Successful' ? "Successful" : items.status === 'Pending' ? "Pending" : "Failed"}</Tag>

      };
    });

  return (
    <div className="mainContain">
      <h1 className="transaction">Transactions</h1>
      <div className="d-flex gap-3">
        <p onClick={HandleChange} className="suntaginactive">Transaction</p>
        <p className="suntag">Refund</p>
      </div>
      <div className="datesearchFi">
        <div className="d-flex">
          <select className="" onClick={(e) => {
            if (e.target.value === "Transaction ID") { setfilterText('Transaction ID, Email ID') } else {
              setfilterText(e.target.value)
            }
          }} style={{ outline: 'none', border: "0px solid transparent", padding: '4px 8px', borderRadius: '4px 0px 0px 4px' }}>
            <option>Transaction ID</option>
            <option>First Value</option>
            <option>Ref ID</option>
            <option>PRICE ID</option>
            <option>Revgg ID</option>
          </select>
          <input
            type="text"
            style={{ width: "350px",border:'0px solid transparent',outline:'none',padding:'4px 8px',borderRadius:'0px 4px 4px 0px' }}
            placeholder={`Search by ${filterText}`}
            // className="inputSearch"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <div className="inputfatef">
          <div>
            <DatePicker
              value={fromDate}
              style={{ width: "100%", border: "none",backgroundColor:'white' }}
              placeholder="From(DD-MM-YYYY)"
              onChange={handleFromDateChange}
              format='DD-MM-YYYY'
              suffixIcon={<CalendarOutlined style={{ color: "rgba(22, 22, 22, 0.25)" }} />}
            />
          </div>
          <div>
            <DatePicker
              value={toDate}
              style={{ width: "100%", border: "none",backgroundColor:'white' }}
              placeholder="To(DD-MM-YYYY)"
              onChange={handleToDateChange}
              format='DD-MM-YYYY'
              suffixIcon={<CalendarOutlined style={{ color: "rgba(22, 22, 22, 0.25)" }} />}
            />
          </div>
        </div>

      </div>
      <div className="cardClass">
        <div className="cardpayment">
          <div>Total Payment</div>
          <span>₹ 34,26,023</span>
        </div>
        <div className="cardpayment">
          <div>Total Payment</div>
          <span>₹ 34,26,023</span>
        </div>
        <div className="cardpayment">
          <div>Total Payment</div>
          <span>₹ 34,26,023</span>
        </div>
      </div>
      <div className="mt-3">
        <Table
          columns={columns}
          dataSource={data}
          loading={loading}
          pagination={{
            total: jsonData.totalData,
            current: tableParams.current,
            pageSize: tableParams.pageSize,
            showSizeChanger: true,
            showQuickJumper: true,
            pageSizeOptions: ['10', '20', '50'],
          }}
        // onChange={handleTableChange}
        />

      </div>
    </div>
  );
}

export default Refund;
